<template>
  <el-color-picker
    v-model="data" popper-class="theme-picker-dropdown" :disabled="disabled"
    @change="onChange"
  />
</template>
<script>
export default {
  props: ['value', 'disabled'],
  data() {
    return {
      data: '',
    };
  },
  watch: {
    data() {
      this.$emit('input', this.data);
    },
  },
  mounted() {
    this.data = this.value;
  },
  methods: {
    onChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>
<style>
.theme-picker .el-color-picker__trigger {
  vertical-align: middle;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
  display: none;
}
</style>
